/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Adjust_FiltersInputs */



/**
* | output |
* | --- |
* | "Try adjusting your filters." |
*
* @param {User_List_Adjust_FiltersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_adjust_filters = /** @type {((inputs?: User_List_Adjust_FiltersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Adjust_FiltersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Essayez d'ajuster vos filtres.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Intente ajustar sus filtros.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Tente ajustar seus filtros.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prova a modificare i filtri.")
	return /** @type {LocalizedString} */ ("Try adjusting your filters.")
});